/**
 * Centralized logging utility for image compression operations
 */

export const compressionLogger = {
  /**
   * Log successful compression with statistics
   */
  success: (
    originalSize: number,
    compressedSize: number,
    format: string,
    dimensions?: { width: number; height: number }
  ) => {
    const savings = (((originalSize - compressedSize) / originalSize) * 100).toFixed(1);
    console.log(
      `[Image Compression] Success\n` +
        `  Size: ${originalSize} → ${compressedSize} bytes (${savings}% smaller)\n` +
        `  Format: ${format.toUpperCase()}` +
        (dimensions ? `\n  Dimensions: ${dimensions.width}x${dimensions.height}` : "")
    );
  },

  /**
   * Log fallback to client-side compression
   */
  fallback: (error: Error | unknown) => {
    const message = error instanceof Error ? error.message : String(error);
    console.warn(
      `[Image Compression] Server compression failed, using client-side fallback`,
      message
    );
  },

  /**
   * Log compression failure
   */
  error: (error: Error | unknown) => {
    console.error("[Image Compression] Failed:", error);
  },

  /**
   * Log client-side compression statistics
   */
  clientSide: (originalSize: number, compressedSize: number) => {
    const savings = (((originalSize - compressedSize) / originalSize) * 100).toFixed(1);
    console.log(
      `[Client Compression] ${originalSize} → ${compressedSize} bytes (${savings}% smaller)`
    );
  },
};
